import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { connect } from "react-redux";

import Headline from "../../Headline/Headline";
import UserInformations from "./UserInformations";
import Settings from "./Settings";
import Historic from "./Historic";
import Options from "./Options";
import Pwd from "./Password";
import Logs from "./Logs";
import SearchPreferences from "./SearchPreferences";
import RegisterDeveloper from "./RegisterDeveloper";
import Documentation from "./Documentation";

import * as AuthenticationUtils from "../../../middleware/Utils/AuthenticationUtils";
import * as ChannelActions from "../../../middleware/Store/Actions/ChannelActions";
import * as ChannelUtils from "../../Utils/ChannelUtils";
import * as ContactUtils from "../../Utils/ContactUtils";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "SETTINGS-PROFILE";
export const RegisterHashTag = "registerHashTag";
export const OptionHashTag = "optionHashTag";

const Profile = (props) => {
    const intl = useIntl();

    useEffect(() => {
        LogService.trace(LOG_TAG, "use effect didmount")
        if (!props.isHubChannelExist) {
            props.getInformationChannel();
        }
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        LogService.trace(LOG_TAG, "use effect location")
        if (props.location?.hash?.length > 0 && props.location.hash.substring(1) === RegisterHashTag) {
            scrollToHashTag(RegisterHashTag);
        }

        if (props.location?.hash?.length > 0 && props.location.hash.substring(1) === OptionHashTag) {
            scrollToHashTag(OptionHashTag);
        }
    }, [props.location]);

    function scrollToHashTag(hashTag) {
        const element = document.getElementById(hashTag);
        if (element) {
            element.scrollIntoView();
            // window.scrollTo(0, element.offsetTop);
        }
    }

    LogService.info(LOG_TAG, "Enter");
    const title = intl.messages.profileTitle;
    const subtitle = intl.messages.profileMessage;
    
    const isDeveloper = ContactUtils.isDeveloper(props.user);
    const isSupport = ContactUtils.isSupportOrAppSupport(props.user);
    const isSuperAdmin = ContactUtils.isSuperAdmin(props.user);
    let showDeveloperRegistration = !isSuperAdmin && !isSupport || isDeveloper;

    return (
        <div>
            <Headline
                title={title}
                subtitle={subtitle}
            />
            <div className="row">
                <div className="col-xxl-9 col-lg-8">
                    <UserInformations />
                    {props.isRainbowAuthentication && <Pwd />}
                    <a id={OptionHashTag} />
                    {props.isHubChannelExist && <Options />}
                    <a id={RegisterHashTag} />
                    { showDeveloperRegistration && <RegisterDeveloper /> }
                </div>

                <div className="col-xxl-3 col-lg-4">
                    <SearchPreferences />
                    <Documentation />
                    <Settings />
                    <Historic />
                    <Logs />
                </div>
            </div>
        </div>
    );
}

Profile.propTypes = {
    user: PropTypes.object,
    channel: PropTypes.object,
    isRainbowAuthentication: PropTypes.bool,
    isHubChannelExist: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        user: state.contacts.user,
        channel: state.channel.data,
        isRainbowAuthentication: AuthenticationUtils.isRainbowAuthentication(state.authentication.account),
        isHubChannelExist: ChannelUtils.isHubChannelExist(state.channel)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getInformationChannel: () => dispatch(ChannelActions.getInformationChannel())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile);